export default __webpack_public_path__ + "static/media/Banner_image_Delft.3700b7ae.jpg";